<section class="tokenomics" id="tokenomics">
  <div class="container">
    <h2 class="section-title text-center pe-5 pe-sm-0">{{ 'tokenomics.title' | translate }}</h2>
    <p class="section-desc text-center mx-auto mwx-1000 pb-3">{{ 'tokenomics.desc' | translate }}</p>
    <div class="row align-items-center justify-content-between mt-4 tokenomics-wrapper mt-5">
      <div class="col-lg-4 d-block d-sm-none">
        <img src="/assets/images/webp/tokenomics.webp" class="img-fluid middle-image" alt="tokenomics" loading="lazy" />
      </div>
      <div class="col-lg-4">
        <div class="tokenomics-box">
          <div class="d-flex align-items-center justify-content-between mb-3 pb-1 w-100" *ngFor="let item of items1">
            <div class="d-flex align-items-center">
              <img src="/assets/images/webp/{{ item.img }}" class="img-fluid me-3 toke-icon" loading="lazy"
                alt="{{ item.alt | translate }}" />
              <div>
                <p class="mb-0 toke-title font-16 fw-medium">
                  {{ item.title | translate }}
                </p>
                <span class="font-12 fw-medium toke-amount">{{ item.amount | translate }}</span>
              </div>
            </div>
            <span class="toke-per font-20">{{ item.per | translate }}</span>
          </div>
        </div>
      </div>

      <div class="col-lg-4 d-none d-sm-block">
        <img src="/assets/images/webp/tokenomics.webp" class="img-fluid middle-image" alt="tokenomics" loading="lazy" />
      </div>

      <div class="col-lg-4">
        <div class="tokenomics-box">
          <div class="d-flex align-items-center justify-content-between mb-3 pb-1 w-100" *ngFor="let item of items2">
            <div class="d-flex align-items-center">
              <img src="/assets/images/webp/{{ item.img }}" class="img-fluid me-3 toke-icon" loading="lazy"
                alt="{{ item.alt | translate }}" />
              <div>
                <p class="mb-0 toke-title font-16 fw-medium">
                  {{ item.title | translate }}
                </p>
                <span class="font-12 fw-medium toke-amount">{{ item.amount | translate }}</span>
              </div>
            </div>
            <span class="toke-per font-20">{{ item.per | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="token-info mt-4 pt-3">
      <h3 class="section-title fw-medium font-32 mb-4">
        {{ "tokenomics.title_2" | translate }}
      </h3>
      <p class="section-desc mw-100 opacity-7">
        {{ "tokenomics.desc_2" | translate }}
      </p>
      <div class="row mt-4">
        <div class="col-lg-6 mb-3">
          <div class="d-flex align-items-center info-box">
            <span></span>
            <p class="mb-0 font-17">{{ "tokenomics.para_1" | translate }}</p>
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="d-flex align-items-center info-box">
            <span></span>
            <p class="mb-0 font-17">{{ "tokenomics.para_2" | translate }}</p>
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="d-flex align-items-center info-box">
            <span></span>
            <p class="mb-0 font-17">{{ "tokenomics.para_3" | translate }}</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="d-flex align-items-center info-box">
            <span></span>
            <p class="mb-0 font-17">{{ "tokenomics.para_4" | translate }}</p>
          </div>
        </div>
      </div>

      <p class="section-desc mt-4 mw-100 opacity-7">
        {{ "tokenomics.desc_3" | translate }}
      </p>
    </div> -->
  </div>
</section>
